import React, { useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useClient } from "ClientContext";
import { useIframeMessage } from "hooks/useIframeMessage";

const ListingResolverBeta: React.FC = () => {
  const { requestType, internal_ID, global_searh } = useClient();
  const navigate = useNavigate();

  const { listing_id, timeoutError, loading } = useIframeMessage();

  // Extract navigation logic for better reusability and memoization
  const handleNavigation = useCallback(() => {
    if (!requestType || loading || internal_ID === "n/a") return;

    switch (requestType) {
      case "ALL_LISTINGS":
        navigate(`/listings-list`);
        break;

      case "ALL_CALENDAR_LISTINGS":
        navigate(`/listings-Calendar`);
        break;

      case "SINGLE_LISTING":
        if (listing_id) {
          navigate(`/listings-list/${listing_id}`);
        }
        break;

      case "SEARCH_LISTINGS":
        if (global_searh?.params) {
          const { checkIn, checkOut, guestsCount, location } =
            global_searh.params;
          navigate(`/search/${checkIn}/${checkOut}/${guestsCount}/${location}`);
        }
        break;

      default:
        if (process.env.NODE_ENV === "development") {
          console.warn("Unknown requestType:", requestType);
        }
    }
  }, [
    requestType,
    navigate,
    listing_id,
    global_searh?.params,
    loading,
    internal_ID,
  ]);

  // Trigger navigation based on state changes
  useEffect(() => {
    handleNavigation();
  }, [handleNavigation]);

  // Render loading or error states
  if (loading || internal_ID === "n/a") {
    return (
      <div className="flex justify-center items-center h-screen">
        <div>Loading...</div>
      </div>
    );
  }

  if (timeoutError) {
    return (
      <div
        className="flex justify-center items-center h-screen"
        style={{ color: "red" }}
      >
        Timeout occurred. Please refresh the page or{" "}
        <button onClick={() => window.location.reload()}>Retry</button>.
      </div>
    );
  }

  // No further rendering is required since routing has been handled
  return null;
};

export default ListingResolverBeta;
